import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import ColumnChartEvolutionInadimplencia from '@/components/Base/ColumnChartEvolutionInadimplencia';
import { useConsolidationScoreInadimplenciaEvolucao } from './api/getConsolidationScoreInadimplenciaEvolucao';

const ScoreInadimplenciaCategoriaEvolucao = ({ year, month, setListYears }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreInadimplenciaEvolucao();

  const [yearLocal, setYearLocal] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched) {
      const currentYear = new Date().getFullYear();
      const listYears = Object.keys(groupBy(data, 'ano'))
        .map((item) => Number(item))
        .sort((a, b) => b - a);
      setListYears(listYears);
      if (listYears.length) {
        setYearLocal(year === null ? currentYear : year);
      }
    }
  }, [isFetched, data, year]);

  const selectedData = data?.length ? data?.find((item) => Number(item.ano) === year) : null;

  return (
    <>
      <LoadingChart loading={isFetching} />

      <ColumnChartEvolutionInadimplencia selectedData={selectedData} />
    </>
  );
};

export default ScoreInadimplenciaCategoriaEvolucao;
